module.exports = __webpack_public_path__ + "img/check-arrow.4f37dc5f.svg";